<template>
    <BreadCrumb PageTitle="Ajouter un partenaire" />
    <AddPartenaire />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddPartenaire from "@/components/Partenaires/AddPartenaire.vue";


export default defineComponent({
    name: "AddPartenairePage",
    components: {
        BreadCrumb,
        AddPartenaire,
    },
});
</script>